export enum SocialMediaTypeStatusEnum {
  ACTIVE = "a",
  INACTIVE = "i",
  DELETED = "x",
}

export type SocialMediaTypeStatusTypes = `${SocialMediaTypeStatusEnum}`;

export enum SocialMediaTypeIdEnum {
  INSTAGRAM = 1,
  FACEBOOK = 2,
  X = 3,
  TIKTOK = 4,
  TWITCH = 5,
}

export type SocialMediaTypeIdTypes =
  (typeof SocialMediaTypeIdEnum)[keyof typeof SocialMediaTypeIdEnum];

export interface ISocialMediaTypeDTO {
  id: number;
  name: string;
  description_short: string;
  status: SocialMediaTypeStatusTypes;
  createdAt: string;
  updatedAt: string;
}
